import request from '@/utils/request';

/**
 * 机构线索数据统计
 */
export async function statPage(params: any) {
  return request('/crm-campus/orgLeads/statPage', {
    method: 'POST',
    data: params,
  });
}

/**
 * 机构线索数据统计导出
 */
export async function statExport(params: any) {
  return request('/crm-campus/orgLeads/statExport', {
    method: 'POST',
    data: params,
    responseType: 'blob',
  });
}

/**
 * 获取全部学校
 */
export async function getSchoolList(params: any) {
  return request('/crm-campus/school/list', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}
